/** Pure browser geometry helpers shared by public use cases and the local library. */
export const scrollBehavior = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

export function carouselEdges(element) {
  if (!element?.firstElementChild) return { start: true, end: true };
  const viewport = element.getBoundingClientRect();
  const first = element.firstElementChild.getBoundingClientRect();
  const last = element.lastElementChild.getBoundingClientRect();
  // Scroll snapping may stop at the first card's padded origin rather than zero.
  return { start: first.left >= viewport.left - 2, end: last.right <= viewport.right + 2 };
}
export function carouselStep(element) {
  if (!element?.firstElementChild) return 0;
  const gap = Number.parseFloat(window.getComputedStyle(element).columnGap) || 0;
  return element.firstElementChild.getBoundingClientRect().width + gap;
}
export function revealSection(event, id) {
  const section = document.getElementById(id);
  if (!section?.scrollIntoView) return;
  event.preventDefault();
  section.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
}
